import { render, staticRenderFns } from "./TourFields.vue?vue&type=template&id=3e834517&"
import script from "./TourFields.vue?vue&type=script&lang=js&"
export * from "./TourFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports